export function computePreviewZoom(paneWidth: number, pageWidth: number): number {
  if (paneWidth <= 0 || pageWidth <= 0) return 1;
  return Math.min(1, paneWidth / pageWidth);
}
